import { createApp } from "vue";
import {
  ElAlert,
  ElButton,
  ElCheckbox,
  ElCheckboxGroup,
  ElDialog,
  ElDrawer,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElEmpty,
  ElForm,
  ElFormItem,
  ElIcon,
  ElInput,
  ElInputNumber,
  ElLink,
  ElLoading,
  ElOption,
  ElPagination,
  ElProgress,
  ElRadioButton,
  ElRadioGroup,
  ElResult,
  ElSelect,
  ElSpace,
  ElSwitch,
  ElTable,
  ElTableColumn,
  ElTag,
  ElTooltip,
  ElTree,
  ElUpload,
} from "element-plus";
import "element-plus/dist/index.css";
import { createPinia } from "pinia";
import App from "./App.vue";
import { iconComponents } from "./icons";
import router from "./router";
import "./styles.scss";

const app = createApp(App);
for (const [key, component] of Object.entries(iconComponents)) app.component(key, component);
for (const component of [
  ElAlert, ElButton, ElCheckbox, ElCheckboxGroup, ElDialog, ElDrawer, ElDropdown,
  ElDropdownItem, ElDropdownMenu, ElEmpty, ElForm, ElFormItem, ElIcon, ElInput,
  ElInputNumber, ElLink, ElOption, ElPagination, ElProgress, ElRadioButton, ElRadioGroup, ElResult,
  ElSelect, ElSpace, ElSwitch, ElTable, ElTableColumn, ElTag, ElTooltip, ElTree, ElUpload,
]) app.component(component.name!, component);
app.directive("loading", ElLoading.directive);
app.use(createPinia()).use(router).mount("#app");
